'use client';

import Box from '@mui/material/Box';
import {
	DataGridPro,
	GridColDef,
	GridRowId,
	GridRowModel,
	GridRowModes,
	GridRowModesModel,
	useGridApiRef,
} from '@mui/x-data-grid-pro';
import { GridToolbarSlot, gridToolbarProps } from '@parkchirp/ui-library';
import { useState } from 'react';

import { datagridFilterPanelAttributes, isValidEmail } from '../../utils';
import { DataGridAddBatchToolbar } from './addSubscriptionInvoiceEmail';
import { SubscriptionInvoiceEmailActions, SubscriptionInvoiceEmailColumns } from './config';

export const SubscriptionInvoiceEmailTable = ({ rows, setRows, isEditMode, setShowSnackbar }) => {
	const apiRef = useGridApiRef();
	const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});
	const columns: GridColDef[] = SubscriptionInvoiceEmailColumns({
		editable: isEditMode,
		subscriptionInvoiceEmailActions: SubscriptionInvoiceEmailActions({
			rowModesModel,
			rows,
			setRows,
			setRowModesModel,
			isEditingAllowed: isEditMode,
		}),
	});

	const keepRowEditable = (id: GridRowId) => {
		setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
	};

	const processRowUpdate = async (newRow: GridRowModel) => {
		if (!newRow.email) {
			keepRowEditable(newRow.id);
			setShowSnackbar({
				message: 'Email address is required.',
				severity: 'error',
			});
			return newRow;
		}
		if (!isValidEmail(newRow.email)) {
			keepRowEditable(newRow.id);
			setShowSnackbar({
				message: `The email address ${newRow.email} is invalid`,
				severity: 'error',
			});
			return newRow;
		}
		const rowsUpdated = rows
			.map((row) => (row.id === newRow.id ? newRow : row))
			.map(({ id, payor_id, action, email }) => ({
				id,
				payor_id,
				action,
				email,
			}));
		setRows(rowsUpdated);
		return { ...newRow, isNew: false };
	};
	return (
		<Box sx={{ marginTop: 5, flexGrow: 1, padding: '1em' }}>
			<DataGridPro
				columns={columns}
				apiRef={apiRef}
				rows={rows}
				rowHeight={38}
				autoHeight
				editMode='row'
				processRowUpdate={processRowUpdate}
				rowModesModel={rowModesModel}
				slotProps={{
					toolbar: gridToolbarProps(
						(args) =>
							isEditMode &&
							DataGridAddBatchToolbar({
								...args,
							}),
						{
							setRows,
							setRowModesModel,
							idIndex: rows.length + 1,
							loading: false,
						},
					),
					filterPanel: { ...datagridFilterPanelAttributes },
				}}
				slots={{
					toolbar: GridToolbarSlot,
				}}
			/>
		</Box>
	);
};
